export default __webpack_public_path__ + "static/media/neqatsi-logo-word.db6d7879.webp";